import { css } from 'styled-components';
import { lighten } from 'polished';

// colors:
// 'light',
// 'dark',
// 'grey',
// 'primary',
// 'standout',
// 'custom',

// shadowed by Wijnne, make sure to not break the params
const getBackgroundColor = (theme, color, customColor) => {
  switch (color) {
    case 'transparent':
      return 'transparent';
    case 'softPrimary':
      return lighten(0.5, theme.primaryColor);
    case 'light':
      return theme.pagebuilder?.backgroundLight || 'white';
    case 'dark':
      return theme.pagebuilder?.backgroundDark || theme.grayDarkColor;
    case 'grey':
      return theme.pagebuilder?.backgroundGrey || theme.grayLightColor;
    case 'primary':
      return theme.primaryColor;
    case 'standout':
      return theme.standoutColor;
    case 'custom':
      return customColor;
    default:
      return 'none';
  }
};

export default (theme, color, customColor) => css`
  background-color: ${getBackgroundColor(theme, color, customColor)};
`;
